import React from 'react';
import { Link as Slide } from 'react-scroll';

import Button from '../UI/button/Button';

import './Bio.css';

const Bio = () => {
    return (
        <div id="bio">
            <div className=" container">
                <p className="bio-text">
                <span >One Rock</span> aims at providing companies as well as individuals a creative way of letting out their stories to their audience
                in the form of <span >videos</span>, <span >photos</span>, and <span >graphics</span> and enhance their business.<br/>
                <span className="bio-white">"One-stop solution to your next creative need"</span> <br/>
                Let's work together on your next project!              
                </p>
                <div style={{textAlign:'center'}}>
                    <Slide to="contact" smooth={true}><Button size="large" color="#ffffff">Contact</Button></Slide>
                </div>
            </div>
        </div>
    );
};

export default Bio;


// WEBPACK FOOTER //
// ./src/components/bio/Bio.js